import React from "react";
import Gallery from "../components/Gallery";
import { useLang } from "../context/LanguageContext";

const GalleryPage = () => {
  const { t } = useLang();
  return (
    <main data-testid="gallery-page" className="pt-32 lg:pt-40">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-8 lg:mb-12">
        <p className="overline text-[color:var(--ink-3)]">{t.gallery.eyebrow}</p>
      </div>
      <Gallery />
    </main>
  );
};

export default GalleryPage;
